// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { FaPlus, FaUserShield, FaTrash, FaSearch } from "react-icons/fa";
// import { HiOutlineChevronLeft } from "react-icons/hi";
// import { HiChevronRight } from "react-icons/hi2";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;

// function AllSubadminList() {
//   const [subadmins, setSubadmins] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchEmail, setSearchEmail] = useState("");
//   const [isFilterActive, setIsFilterActive] = useState(false);

//   const getAuthToken = () => localStorage.getItem("token");

//   const handleToggle = () => setIsFilterActive(!isFilterActive);

//   const fetchSubadmins = async (page = 1, email = "") => {
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Authentication token not found. Please log in.");

//       const response = await fetch(
//         `${API_URL}/sub-admin-list?page=${page}&limit=10&email=${email}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) throw new Error("Unauthorized: Please log in again.");
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch sub-admins.");
//       }

//       const data = await response.json();
//       setSubadmins(data.data || []);
//       setTotalPages(data.data.totalPages || 1);
//       setCurrentPage(page);
//     } catch (err) {
//       console.error("Fetch sub-admins error:", err);
//       setError(err.message);
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSubadmins(currentPage, searchEmail);
//   }, [currentPage, searchEmail]);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchEmail(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleStatusUpdate = async (subadminId, currentStatus) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to change the status to ${
//         currentStatus === "active" ? "inactive" : "active"
//       }?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, change it!",
//       cancelButtonText: "No, cancel!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) throw new Error("Authentication token not found.");

//           const newStatus = currentStatus === "active" ? "inactive" : "active";
//           const response = await fetch(`${API_URL}/sub-admin-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: subadminId, status: newStatus }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to update status.");
//           }

//           Swal.fire("Success", "Status updated successfully!", "success");
//           fetchSubadmins(currentPage, searchEmail);
//         } catch (err) {
//           setError(err.message);
//           Swal.fire("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     });
//   };

//   const handleDeleteSubAdmin = async (subadminId, subadminEmail) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to delete sub-admin with email: ${subadminEmail}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "No, cancel!",
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) throw new Error("Authentication token not found.");

//           const response = await fetch(`${API_URL}/delete-sub-admin`, {
//             method: "delete",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: subadminId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete sub-admin.");
//           }

//           Swal.fire("Deleted!", "Sub-admin has been deleted successfully!", "success");
//           fetchSubadmins(currentPage, searchEmail);
//         } catch (err) {
//           setError(err.message);
//           Swal.fire("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     });
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "80vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         }}
//       >
//         <div
//           style={{
//             width: "50px",
//             height: "50px",
//             border: "4px solid #e2e8f0",
//             borderTop: "4px solid #1e5799",
//             borderRadius: "50%",
//             animation: "spin 0.8s linear infinite",
//           }}
//         />
//         <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="padding_15">
//         <div
//           style={{
//             background: "#fef2f2",
//             border: "1.5px solid #fecaca",
//             borderRadius: "16px",
//             padding: "30px",
//             textAlign: "center",
//             color: "#dc2626",
//           }}
//         >
//           <h4 style={{ marginBottom: "12px" }}>⚠️ {error}</h4>
//           <button
//             onClick={() => fetchSubadmins()}
//             style={{
//               background: "#1e5799",
//               color: "#fff",
//               border: "none",
//               padding: "10px 24px",
//               borderRadius: "10px",
//               fontWeight: "700",
//               cursor: "pointer",
//             }}
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "1400px",
//           margin: "0 auto",
//           background: "#ffffff",
//           borderRadius: "20px",
//           boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//           border: "1.5px solid #e2e8f0",
//           overflow: "hidden",
//         }}
//       >
//         {/* 🎯 GRADIENT TOP BAR */}
//         <div
//           style={{
//             height: "5px",
//             background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//           }}
//         />

//         {/* 🎯 HEADER */}
//         <div
//           style={{
//             padding: "24px 30px",
//             borderBottom: "1.5px solid #e2e8f0",
//             background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             {/* Left — Title */}
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 <FaUserShield />
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   All Sub Admins
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Manage all sub admin accounts
//                 </p>
//               </div>
//             </div>

//             {/* Right — Search + Filter + Add */}
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 flexWrap: "wrap",
//               }}
//             >
//               {/* Search (Desktop) */}
//               <div className="d-none d-md-block" style={{ position: "relative" }}>
//                 <span
//                   style={{
//                     position: "absolute",
//                     left: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#1e5799",
//                     fontSize: "13px",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   <FaSearch />
//                 </span>
//                 <input
//                   type="text"
//                   placeholder="Search by email..."
//                   value={searchEmail}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: "240px",
//                     padding: "10px 14px 10px 36px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     transition: "all 0.25s ease",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = "#1e5799";
//                     e.target.style.boxShadow = "0 0 0 4px rgba(30,87,153,0.1)";
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = "#e2e8f0";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//               </div>

//               {/* Filter Toggle (Mobile) */}
//               <button
//                 className="d-block d-md-none"
//                 onClick={handleToggle}
//                 style={{
//                   width: "42px",
//                   height: "42px",
//                   borderRadius: "10px",
//                   border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
//                   background: isFilterActive
//                     ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                     : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "18px",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                 }}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>

//               {/* Add Button — Right Side */}
//               <Link
//                 to="/create-subadmin"
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "10px 20px",
//                   borderRadius: "10px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "13.5px",
//                   fontWeight: "700",
//                   textDecoration: "none",
//                   boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
//                   transition: "all 0.25s ease",
//                   whiteSpace: "nowrap",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = "translateY(-2px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 10px 24px rgba(30, 87, 153, 0.45)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow =
//                     "0 6px 18px rgba(30, 87, 153, 0.3)";
//                 }}
//               >
//                 <FaPlus />
//                 Add Sub Admin
//               </Link>
//             </div>
//           </div>

//           {/* 🎯 Filter Section (Mobile Toggle) */}
//           {isFilterActive && (
//             <div
//               style={{
//                 marginTop: "16px",
//                 paddingTop: "16px",
//                 borderTop: "1.5px dashed #e2e8f0",
//                 display: "flex",
//                 gap: "10px",
//               }}
//             >
//               <div style={{ position: "relative", flex: 1 }}>
//                 <span
//                   style={{
//                     position: "absolute",
//                     left: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#1e5799",
//                     fontSize: "13px",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   <FaSearch />
//                 </span>
//                 <input
//                   type="text"
//                   placeholder="Search by email..."
//                   value={searchEmail}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px 10px 36px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                   }}
//                 />
//               </div>
//             </div>
//           )}
//         </div>

//         {/* 🎯 TABLE */}
//         <div style={{ padding: "24px 30px" }}>
//           <div
//             style={{
//               overflowX: "auto",
//               borderRadius: "14px",
//               border: "1.5px solid #e2e8f0",
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "13.5px",
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   }}
//                 >
//                   {["S.N", "Email", "Password", "Date", "Status", "Delete", "Action", "Permissions"].map(
//                     (th, i) => (
//                       <th
//                         key={i}
//                         style={{
//                           padding: "14px 16px",
//                           color: "#ffffff",
//                           fontWeight: "700",
//                           fontSize: "12.5px",
//                           textAlign: "left",
//                           letterSpacing: "0.5px",
//                           textTransform: "uppercase",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {th}
//                       </th>
//                     )
//                   )}
//                 </tr>
//               </thead>
//               <tbody>
//                 {subadmins.length > 0 ? (
//                   subadmins.map((subadmin, index) => (
//                     <tr
//                       key={subadmin.id}
//                       style={{
//                         borderBottom: "1px solid #f1f5f9",
//                         transition: "background 0.2s ease",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.background = "#f8fafc";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.background = "transparent";
//                       }}
//                     >
//                       <td
//                         style={{
//                           padding: "14px 16px",
//                           fontWeight: "700",
//                           color: "#1e5799",
//                         }}
//                       >
//                         {index + 1}
//                       </td>
//                       <td
//                         style={{
//                           padding: "14px 16px",
//                           fontWeight: "600",
//                           color: "#1e3a5f",
//                         }}
//                       >
//                         {subadmin.email}
//                       </td>
//                       <td
//                         style={{
//                           padding: "14px 16px",
//                           color: "#64748b",
//                           fontSize: "12.5px",
//                         }}
//                       >
//                         {subadmin.password}
//                       </td>
//                       <td
//                         style={{
//                           padding: "14px 16px",
//                           color: "#64748b",
//                           fontSize: "12.5px",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {subadmin.date}
//                       </td>
//                       <td style={{ padding: "14px 16px" }}>
//                         <span
//                           style={{
//                             display: "inline-block",
//                             padding: "4px 12px",
//                             borderRadius: "20px",
//                             fontSize: "11.5px",
//                             fontWeight: "700",
//                             textTransform: "capitalize",
//                             background:
//                               subadmin.status === "active" ? "#e7f9eb" : "#feeaeb",
//                             color:
//                               subadmin.status === "active" ? "#059669" : "#dc2626",
//                           }}
//                         >
//                           {subadmin.status}
//                         </span>
//                       </td>
//                       <td style={{ padding: "14px 16px" }}>
//                         <button
//                           onClick={() =>
//                             handleDeleteSubAdmin(subadmin.id, subadmin.email)
//                           }
//                           style={{
//                             display: "inline-flex",
//                             alignItems: "center",
//                             gap: "6px",
//                             padding: "7px 12px",
//                             borderRadius: "8px",
//                             border: "none",
//                             background: "#feeaeb",
//                             color: "#dc2626",
//                             fontSize: "12px",
//                             fontWeight: "700",
//                             cursor: "pointer",
//                             transition: "all 0.2s ease",
//                           }}
//                           onMouseEnter={(e) => {
//                             e.currentTarget.style.background = "#dc2626";
//                             e.currentTarget.style.color = "#ffffff";
//                           }}
//                           onMouseLeave={(e) => {
//                             e.currentTarget.style.background = "#feeaeb";
//                             e.currentTarget.style.color = "#dc2626";
//                           }}
//                         >
//                           <FaTrash style={{ fontSize: "11px" }} />
//                           Delete
//                         </button>
//                       </td>
//                       <td style={{ padding: "14px 16px" }}>
//                         <button
//                           onClick={() =>
//                             handleStatusUpdate(subadmin.id, subadmin.status)
//                           }
//                           style={{
//                             padding: "7px 14px",
//                             borderRadius: "8px",
//                             border: "none",
//                             background:
//                               subadmin.status === "active" ? "#fef3e2" : "#e7f9eb",
//                             color:
//                               subadmin.status === "active" ? "#d97706" : "#059669",
//                             fontSize: "12px",
//                             fontWeight: "700",
//                             cursor: "pointer",
//                             transition: "all 0.2s ease",
//                           }}
//                           onMouseEnter={(e) => {
//                             e.currentTarget.style.background =
//                               subadmin.status === "active" ? "#d97706" : "#059669";
//                             e.currentTarget.style.color = "#ffffff";
//                           }}
//                           onMouseLeave={(e) => {
//                             e.currentTarget.style.background =
//                               subadmin.status === "active" ? "#fef3e2" : "#e7f9eb";
//                             e.currentTarget.style.color =
//                               subadmin.status === "active" ? "#d97706" : "#059669";
//                           }}
//                         >
//                           {subadmin.status === "active" ? "Deactivate" : "Activate"}
//                         </button>
//                       </td>
//                       <td style={{ padding: "14px 16px" }}>
//                         <Link
//                           to={`/subadmin-permission/${subadmin.id}`}
//                           style={{
//                             display: "inline-flex",
//                             alignItems: "center",
//                             gap: "6px",
//                             padding: "7px 12px",
//                             borderRadius: "8px",
//                             background: "#e8f1fb",
//                             color: "#1e5799",
//                             fontSize: "12px",
//                             fontWeight: "700",
//                             textDecoration: "none",
//                             transition: "all 0.2s ease",
//                             whiteSpace: "nowrap",
//                           }}
//                           onMouseEnter={(e) => {
//                             e.currentTarget.style.background = "#1e5799";
//                             e.currentTarget.style.color = "#ffffff";
//                           }}
//                           onMouseLeave={(e) => {
//                             e.currentTarget.style.background = "#e8f1fb";
//                             e.currentTarget.style.color = "#1e5799";
//                           }}
//                         >
//                           <FaUserShield style={{ fontSize: "11px" }} />
//                           Permissions
//                         </Link>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="8"
//                       style={{
//                         padding: "40px",
//                         textAlign: "center",
//                         color: "#94a3b8",
//                         fontWeight: "600",
//                       }}
//                     >
//                       📭 No sub-admins found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 🎯 PAGINATION */}
//           {totalPages > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 marginTop: "20px",
//                 gap: "6px",
//               }}
//             >
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                   transition: "all 0.2s ease",
//                 }}
//               >
//                 <HiOutlineChevronLeft />
//               </button>

//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handlePageChange(index + 1)}
//                   style={{
//                     width: "38px",
//                     height: "38px",
//                     borderRadius: "10px",
//                     border:
//                       index + 1 === currentPage
//                         ? "none"
//                         : "1.5px solid #e2e8f0",
//                     background:
//                       index + 1 === currentPage
//                         ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                         : "#ffffff",
//                     color: index + 1 === currentPage ? "#ffffff" : "#334155",
//                     fontWeight: "700",
//                     fontSize: "13px",
//                     cursor: "pointer",
//                     transition: "all 0.2s ease",
//                     boxShadow:
//                       index + 1 === currentPage
//                         ? "0 6px 16px rgba(30, 87, 153, 0.3)"
//                         : "none",
//                   }}
//                 >
//                   {index + 1}
//                 </button>
//               ))}

//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                   transition: "all 0.2s ease",
//                 }}
//               >
//                 <HiChevronRight />
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AllSubadminList;
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  FaPlus,
  FaUserShield,
  FaTrash,
  FaSearch,
} from "react-icons/fa";
import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;

function AllSubadminList() {
  const [subadmins, setSubadmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage] = useState(10);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchInput, setSearchInput] = useState(""); // separate input state
  const [isFilterActive, setIsFilterActive] = useState(false);

  const getAuthToken = () => localStorage.getItem("token");

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  // ═══════════════════════════════════════════
  // 🔹 FETCH SUB-ADMINS
  // ═══════════════════════════════════════════
  const fetchSubadmins = async (page = 1, email = "") => {
    setError(null);
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Authentication token not found. Please log in.");

      const response = await fetch(
        `${API_URL}/sub-admin-list?page=${page}&limit=${rowsPerPage}&email=${email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401)
          throw new Error("Unauthorized: Please log in again.");
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch sub-admins.");
      }

      const data = await response.json();

      // ✅ FIX: multiple API response structures handle karo
      const list = data.data || data.subadmins || [];
      const total = data.total || data.totalRecords || data.total_records || list.length;
      const pages =
        data.totalPages ||
        data.total_pages ||
        Math.ceil(total / rowsPerPage) ||
        1;

      setSubadmins(list);
      setTotalRecords(total);
      setTotalPages(pages > 0 ? pages : 1);
      setCurrentPage(page);
    } catch (err) {
      console.error("Fetch sub-admins error:", err);
      setError(err.message);
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Sirf page change pe fetch karo (search pe nahi)
  useEffect(() => {
    fetchSubadmins(currentPage, searchEmail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages && pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // ✅ Search — Enter press pe ya button se
  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    setSearchEmail(searchInput);
    setCurrentPage(1);
    fetchSubadmins(1, searchInput);
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchInput("");
    setSearchEmail("");
    setCurrentPage(1);
    fetchSubadmins(1, "");
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = async (subadminId, currentStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${
        currentStatus === "active" ? "inactive" : "active"
      }?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        setError(null);
        try {
          const token = getAuthToken();
          if (!token) throw new Error("Authentication token not found.");

          const newStatus = currentStatus === "active" ? "inactive" : "active";
          const response = await fetch(`${API_URL}/sub-admin-status-update`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: subadminId, status: newStatus }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update status.");
          }

          Swal.fire("Success", "Status updated successfully!", "success");
          fetchSubadmins(currentPage, searchEmail);
        } catch (err) {
          setError(err.message);
          Swal.fire("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE
  // ═══════════════════════════════════════════
  const handleDeleteSubAdmin = async (subadminId, subadminEmail) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete sub-admin with email: ${subadminEmail}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        setError(null);
        try {
          const token = getAuthToken();
          if (!token) throw new Error("Authentication token not found.");

          const response = await fetch(`${API_URL}/delete-sub-admin`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: subadminId }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to delete sub-admin.");
          }

          Swal.fire(
            "Deleted!",
            "Sub-admin has been deleted successfully!",
            "success"
          );

          // ✅ Agar last item delete hua aur page khali ho gaya to previous page pe jao
          if (subadmins.length === 1 && currentPage > 1) {
            setCurrentPage(currentPage - 1);
          } else {
            fetchSubadmins(currentPage, searchEmail);
          }
        } catch (err) {
          setError(err.message);
          Swal.fire("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // ✅ Smart pagination group
  const getPaginationGroup = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 3) {
      return [1, 2, 3, 4, "...", totalPages];
    }
    if (currentPage >= totalPages - 2) {
      return [
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }
    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading && subadmins.length === 0) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🔹 ERROR
  // ═══════════════════════════════════════════
  if (error && subadmins.length === 0) {
    return (
      <div style={{ padding: "24px" }}>
        <div
          style={{
            background: "#fef2f2",
            border: "1.5px solid #fecaca",
            borderRadius: "16px",
            padding: "30px",
            textAlign: "center",
            color: "#dc2626",
            maxWidth: "600px",
            margin: "60px auto",
          }}
        >
          <h4 style={{ marginBottom: "12px" }}>⚠️ {error}</h4>
          <button
            onClick={() => fetchSubadmins(1, "")}
            style={{
              background: "#1e5799",
              color: "#fff",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🔹 RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: "20px",
          boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
          border: "1.5px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        {/* Top Gradient Bar */}
        <div
          style={{
            height: "5px",
            background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
          }}
        />

        {/* ═══════ HEADER ═══════ */}
        <div
          style={{
            padding: "24px 30px",
            borderBottom: "1.5px solid #e2e8f0",
            background: "linear-gradient(135deg, #ffffff, #f8fafc)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            {/* Left — Title */}
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                <FaUserShield />
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                    letterSpacing: "-0.3px",
                  }}
                >
                  All Sub Admins
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all sub admin accounts ({totalRecords} total)
                </p>
              </div>
            </div>

            {/* Right — Search + Filter + Add */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {/* Search (Desktop) */}
              <form
                onSubmit={handleSearchSubmit}
                className="d-none d-md-flex"
                style={{ position: "relative", alignItems: "center", gap: "8px" }}
              >
                <div style={{ position: "relative" }}>
                  <span
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#1e5799",
                      fontSize: "13px",
                      pointerEvents: "none",
                    }}
                  >
                    <FaSearch />
                  </span>
                  <input
                    type="text"
                    placeholder="Search by email..."
                    value={searchInput}
                    onChange={handleSearchChange}
                    style={{
                      width: "240px",
                      padding: "10px 14px 10px 36px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      fontSize: "13.5px",
                      fontWeight: "500",
                      color: "#1e3a5f",
                      outline: "none",
                      transition: "all 0.25s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#1e5799";
                      e.target.style.boxShadow =
                        "0 0 0 4px rgba(30,87,153,0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e2e8f0";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
                <button
                  type="submit"
                  style={{
                    padding: "10px 18px",
                    borderRadius: "10px",
                    border: "none",
                    background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    color: "#ffffff",
                    fontSize: "13px",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
                  }}
                >
                  Search
                </button>
                {searchEmail && (
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    style={{
                      padding: "10px 16px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      color: "#64748b",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                  >
                    Clear
                  </button>
                )}
              </form>

              {/* Filter Toggle (Mobile) */}
              <button
                className="d-block d-md-none"
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                }}
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>

              {/* Add Button */}
              <Link
                to="/create-subadmin"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13.5px",
                  fontWeight: "700",
                  textDecoration: "none",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                  transition: "all 0.25s ease",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 24px rgba(30, 87, 153, 0.45)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 18px rgba(30, 87, 153, 0.3)";
                }}
              >
                <FaPlus />
                Add Sub Admin
              </Link>
            </div>
          </div>

          {/* Mobile Filter Section */}
          {isFilterActive && (
            <form
              onSubmit={handleSearchSubmit}
              style={{
                marginTop: "16px",
                paddingTop: "16px",
                borderTop: "1.5px dashed #e2e8f0",
                display: "flex",
                gap: "10px",
              }}
            >
              <div style={{ position: "relative", flex: 1 }}>
                <span
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#1e5799",
                    fontSize: "13px",
                    pointerEvents: "none",
                  }}
                >
                  <FaSearch />
                </span>
                <input
                  type="text"
                  placeholder="Search by email..."
                  value={searchInput}
                  onChange={handleSearchChange}
                  style={{
                    width: "100%",
                    padding: "10px 14px 10px 36px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    fontSize: "13.5px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    outline: "none",
                  }}
                />
              </div>
              <button
                type="submit"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                Search
              </button>
            </form>
          )}
        </div>

        {/* ═══════ TABLE ═══════ */}
        <div style={{ padding: "24px 30px" }}>
          <div
            style={{
              overflowX: "auto",
              borderRadius: "14px",
              border: "1.5px solid #e2e8f0",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "13.5px",
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  }}
                >
                  {[
                    "S.N",
                    "Email",
                    "Password",
                    "Date",
                    "Status",
                    "Delete",
                    "Action",
                    "Permissions",
                  ].map((th, i) => (
                    <th
                      key={i}
                      style={{
                        padding: "14px 16px",
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "12.5px",
                        textAlign: "left",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {th}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subadmins.length > 0 ? (
                  subadmins.map((subadmin, index) => (
                    <tr
                      key={subadmin.id}
                      style={{
                        borderBottom: "1px solid #f1f5f9",
                        transition: "background 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#f8fafc";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                      }}
                    >
                      <td
                        style={{
                          padding: "14px 16px",
                          fontWeight: "700",
                          color: "#1e5799",
                        }}
                      >
                        {(currentPage - 1) * rowsPerPage + index + 1}
                      </td>
                      <td
                        style={{
                          padding: "14px 16px",
                          fontWeight: "600",
                          color: "#1e3a5f",
                        }}
                      >
                        {subadmin.email}
                      </td>
                      <td
                        style={{
                          padding: "14px 16px",
                          color: "#64748b",
                          fontSize: "12.5px",
                        }}
                      >
                        {subadmin.password}
                      </td>
                      <td
                        style={{
                          padding: "14px 16px",
                          color: "#64748b",
                          fontSize: "12.5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {subadmin.date}
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "11.5px",
                            fontWeight: "700",
                            textTransform: "capitalize",
                            background:
                              subadmin.status === "active"
                                ? "#e7f9eb"
                                : "#feeaeb",
                            color:
                              subadmin.status === "active"
                                ? "#059669"
                                : "#dc2626",
                          }}
                        >
                          {subadmin.status}
                        </span>
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <button
                          onClick={() =>
                            handleDeleteSubAdmin(subadmin.id, subadmin.email)
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "7px 12px",
                            borderRadius: "8px",
                            border: "none",
                            background: "#feeaeb",
                            color: "#dc2626",
                            fontSize: "12px",
                            fontWeight: "700",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#dc2626";
                            e.currentTarget.style.color = "#ffffff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#feeaeb";
                            e.currentTarget.style.color = "#dc2626";
                          }}
                        >
                          <FaTrash style={{ fontSize: "11px" }} />
                          Delete
                        </button>
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <button
                          onClick={() =>
                            handleStatusUpdate(subadmin.id, subadmin.status)
                          }
                          style={{
                            padding: "7px 14px",
                            borderRadius: "8px",
                            border: "none",
                            background:
                              subadmin.status === "active"
                                ? "#fef3e2"
                                : "#e7f9eb",
                            color:
                              subadmin.status === "active"
                                ? "#d97706"
                                : "#059669",
                            fontSize: "12px",
                            fontWeight: "700",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              subadmin.status === "active"
                                ? "#d97706"
                                : "#059669";
                            e.currentTarget.style.color = "#ffffff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background =
                              subadmin.status === "active"
                                ? "#fef3e2"
                                : "#e7f9eb";
                            e.currentTarget.style.color =
                              subadmin.status === "active"
                                ? "#d97706"
                                : "#059669";
                          }}
                        >
                          {subadmin.status === "active"
                            ? "Deactivate"
                            : "Activate"}
                        </button>
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <Link
                          to={`/subadmin-permission/${subadmin.id}`}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "7px 12px",
                            borderRadius: "8px",
                            background: "#e8f1fb",
                            color: "#1e5799",
                            fontSize: "12px",
                            fontWeight: "700",
                            textDecoration: "none",
                            transition: "all 0.2s ease",
                            whiteSpace: "nowrap",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#1e5799";
                            e.currentTarget.style.color = "#ffffff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#e8f1fb";
                            e.currentTarget.style.color = "#1e5799";
                          }}
                        >
                          <FaUserShield style={{ fontSize: "11px" }} />
                          Permissions
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      style={{
                        padding: "40px",
                        textAlign: "center",
                        color: "#94a3b8",
                        fontWeight: "600",
                      }}
                    >
                      📭 No sub-admins found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ═══════ PAGINATION ═══════ */}
          {totalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "20px",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {/* Info */}
              <div
                style={{
                  fontSize: "12.5px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Showing{" "}
                <strong style={{ color: "#1e5799" }}>
                  {(currentPage - 1) * rowsPerPage + 1}
                </strong>{" "}
                to{" "}
                <strong style={{ color: "#1e5799" }}>
                  {Math.min(currentPage * rowsPerPage, totalRecords)}
                </strong>{" "}
                of{" "}
                <strong style={{ color: "#1e5799" }}>{totalRecords}</strong>{" "}
                entries
              </div>

              {/* Pagination buttons */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s ease",
                  }}
                >
                  <HiOutlineChevronLeft /> Prev
                </button>

                {getPaginationGroup().map((p, i) => {
                  if (p === "...") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }
                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color:
                      currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages
                        ? "not-allowed"
                        : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s ease",
                  }}
                >
                  Next <HiChevronRight />
                </button>
              </div>
            </div>
          )}

          {/* Info when only 1 page */}
          {totalPages === 1 && subadmins.length > 0 && (
            <p
              style={{
                textAlign: "center",
                fontSize: "12px",
                color: "#94a3b8",
                marginTop: "12px",
                marginBottom: 0,
                fontWeight: "500",
              }}
            >
              Showing all {totalRecords} records
            </p>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default AllSubadminList;